import { memo, useState } from "react";

import { Stack, Typography, CircularProgress, SxProps } from "@mui/material";

import useTimeout from "@app/common/hooks/useTimeout";

interface FullPageLoadingSpinnerWithTextProps {
  darkMode?: boolean;
  delay?: number;
  sx?: SxProps;
  text?: string;
}

const FullPageLoadingSpinnerWithText = memo(
  ({
    darkMode,
    delay = 0,
    text = "Loading Read...",
    sx,
  }: FullPageLoadingSpinnerWithTextProps) => {
    const [show, setShow] = useState(false);

    useTimeout(() => setShow(true), delay, delay > 0);

    return (
      <Stack
        data-test-id="full-page-load-spinner"
        sx={{
          width: "100%",
          height: "100vh",
          bgcolor: darkMode ? "#201f1f" : "#fafafa",
          ...sx,
        }}
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        {(show || delay === 0) && (
          <>
            <CircularProgress
              variant="indeterminate"
              sx={{
                "& .MuiCircularProgress-circle": {
                  strokeLinecap: "round",
                  stroke: "#4C47CC",
                },
              }}
            />
            <Typography
              variant="bodySecondaryReg"
              sx={{
                color: darkMode ? "#fff" : "#000",
                fontSize: "0.875rem",
                lineHeight: 1.25,
              }}
            >
              {text}
            </Typography>
          </>
        )}
      </Stack>
    );
  }
);

FullPageLoadingSpinnerWithText.displayName = "FullPageLoadingSpinnerWithText";

export default FullPageLoadingSpinnerWithText;
